import {
    faBook,
    faBuilding,
    faClipboardList,
    faFileImport,
    faFileWaveform,
    faGear,
    faUsers,
    faUserShield
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    ACCESS_RIGHT_AREAS,
    ACCESS_RIGHT_TYPES,
} from "../../../constant/permissions";

// Each entry declares how it is gated:
//   - requiredPermission: { area, type } → visible when the user holds that
//     right (global admins always pass).
//   - adminOnly: true                    → visible to global admins only.
//   - neither                            → ungated (visible to every
//     authenticated user, including project-local members with no global role).
const navBarItems = [
    {
        label: "navigation.projects",
        key: "projects",
        icon: <FontAwesomeIcon icon={faBook} />,
        url: "projects",
    },
    {
        label: "navigation.settings",
        key: "settings",
        icon: <FontAwesomeIcon icon={faGear} />,
        url: "settings/user",
        submenu: [
            {
                label: "navigation.users",
                key: "settings-users",
                icon: <FontAwesomeIcon icon={faUsers} />,
                url: "settings/user",
                requiredPermission: {
                    area: ACCESS_RIGHT_AREAS.USERS,
                    type: ACCESS_RIGHT_TYPES.VIEW,
                },
            },
            {
                label: "navigation.roles",
                key: "settings-roles",
                icon: <FontAwesomeIcon icon={faUserShield} />,
                url: "settings/role",
                requiredPermission: {
                    area: ACCESS_RIGHT_AREAS.ROLES,
                    type: ACCESS_RIGHT_TYPES.VIEW,
                },
            },
            {
                label: "navigation.company",
                key: "settings-company",
                icon: <FontAwesomeIcon icon={faBuilding} />,
                url: "settings/company",
                requiredPermission: {
                    area: ACCESS_RIGHT_AREAS.COMPANIES,
                    type: ACCESS_RIGHT_TYPES.VIEW,
                },
            },
            {
                label: "navigation.templates",
                key: "settings-templates",
                icon: <FontAwesomeIcon icon={faFileWaveform} />,
                url: "settings/templates",
                requiredPermission: {
                    area: ACCESS_RIGHT_AREAS.TEMPLATE,
                    type: ACCESS_RIGHT_TYPES.VIEW,
                },
            },
            {
                label: "admin.permission-templates.title",
                key: "admin-permission-templates",
                icon: <FontAwesomeIcon icon={faUserShield} />,
                url: "settings/permission-templates",
                requiredPermission: {
                    area: ACCESS_RIGHT_AREAS.PROJECT_PERMISSION_TEMPLATE,
                    type: ACCESS_RIGHT_TYPES.VIEW,
                },
            },
            {
                label: "admin.projects-overview.title",
                key: "admin-projects-overview",
                icon: <FontAwesomeIcon icon={faClipboardList} />,
                url: "admin/projects-overview",
                adminOnly: true,
            },
        ],
    },
    {
        label: "navigation.capmo-import.capmo-import",
        key: "capmo-sync",
        icon: <FontAwesomeIcon icon={faFileImport} />,
        url: "settings/capmo-sync",
        requiredPermission: {
            area: ACCESS_RIGHT_AREAS.CAPMO_IMPORT,
            type: ACCESS_RIGHT_TYPES.VIEW,
        },
    },
];

export { navBarItems };
